function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddPackage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    height: 22,
    id: "screenshot-bb94a6ff-2b51-80bf-8006-935fb990c8e8",
    viewBox: "0 0 22 22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-bb94a6ff-2b51-80bf-8006-935fb990c8e8",
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-bb94a6ff-2b51-80bf-8006-935fb991090b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-bb94a6ff-2b51-80bf-8006-935fb991090b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.510498046875,5.8209228515625C20.9261474609375,5.3240966796875,20.044677734375,5.3916015625,19.5401611328125,5.9764404296875L16.704833984375,9.7662353515625C16.5618896484375,9.7440185546875,5.5078125,9.7440185546875,5.39501953125,9.7578125L2.426513671875,5.959716796875C1.9190673828125,5.3818359375,1.043212890625,5.325439453125,0.47119140625,5.8333740234375C-0.1051025390625,6.34375,-0.1600341796875,7.2259521484375,0.345947265625,7.8065185546875L3.13330078125,11.39404296875C2.964111328125,11.7628173828125,2.8636474609375,12.166015625,2.8636474609375,12.5953369140625L2.8636474609375,19.1265869140625C2.8636474609375,20.711669921875,4.1492919921875,21.999755859375,5.736083984375,21.999755859375L16.270263671875,21.999755859375C17.8555908203125,21.999755859375,19.1427001953125,20.711669921875,19.1427001953125,19.1265869140625L19.1427001953125,12.5953369140625C19.1427001953125,12.197998046875,19.0616455078125,11.822021484375,18.915771484375,11.4752197265625L21.6658935546875,7.787353515625C22.1663818359375,7.202392578125,22.09619140625,6.3218994140625,21.510498046875,5.8209228515625L21.510498046875,5.8209228515625Z",
    fillRule: "evenodd",
    className: "si-glyph-fill",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-bb94a6ff-2b51-80bf-8006-935fb991090c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-bb94a6ff-2b51-80bf-8006-935fb991090c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.82373046875,2.822265625L12.3321533203125,3.335693359375L12.3609619140625,1.3594970703125C12.365234375,0.6015625,11.7574462890625,-0.005615234375,11.00244140625,0.000244140625C10.243408203125,0.0029296875,9.62744140625,0.6207275390625,9.624755859375,1.3790283203125L9.6673583984375,3.295654296875L7.2183837890625,2.822265625C6.8431396484375,3.1982421875,6.8416748046875,3.8062744140625,7.2142333984375,4.1790771484375L10.3287353515625,7.861572265625C10.7012939453125,8.234619140625,11.307861328125,8.233154296875,11.68310546875,7.856201171875L14.8154296875,4.1790771484375C15.192138671875,3.8009033203125,15.195068359375,3.1951904296875,14.82373046875,2.822265625L14.82373046875,2.822265625Z",
    fillRule: "evenodd",
    className: "si-glyph-fill",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddPackage);
export default __webpack_public_path__ + "static/media/icon-add-package.d6321357ea589407a1a9e663b9ecf63b.svg";
export { ForwardRef as ReactComponent };